import React, { PureComponent, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';
import * as modalActions from 'actions/modalActions';
import { AIRLINE_SEAT_LIST, AIRLINE_PASSENGER_LIST } from 'constants/modal';
import { SLIDE_DIRECTION_LEFT } from 'components/Modal/SlideInFromTheSideModal';

import SeatList from 'components/AirlineSeatSelection/SeatList';
import SeatListNavigationHeader from 'components/AirlineSeatSelection/SeatListNavigationHeader';

import './SeatListModal.scss';

/* istanbul ignore next */
const mapStateToProps = state => ({
  seatPassengers: state.bookState.getIn(['booking_info', 'airlineSeatPassenger'], Immutable.List()),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  modalActionsBound: bindActionCreators(modalActions, dispatch),
});

export class SeatListModal extends PureComponent {
  static propTypes = {
    seatPassengers: ImmutablePropTypes.list.isRequired,
    direction: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    passengerIndex: PropTypes.number.isRequired,
    modalActionsBound: PropTypes.shape({
      toggleModal: PropTypes.func.isRequired,
    }).isRequired,
  };

  state = {
    hasSeatBeenSelected: false,
  };

  getSeatPassenger() {
    const { seatPassengers, passengerIndex } = this.props;
    return seatPassengers.get(passengerIndex);
  }

  goToPassenger(passengerIndex) {
    const { modalActionsBound, type, direction } = this.props;

    modalActionsBound.toggleModal(AIRLINE_SEAT_LIST, {
      slideInFromTheSide: SLIDE_DIRECTION_LEFT,
      title: 'In-flight Seat Selection',
      type,
      direction,
      passengerIndex,
    });
  }

  selectPrevious = () => {
    const { passengerIndex } = this.props;

    if (passengerIndex > 0) {
      this.goToPassenger(passengerIndex - 1);
    }
  };

  onSeatSelected = () => {
    const { passengerIndex, seatPassengers, type } = this.props;
    if (type === 'all' && passengerIndex < seatPassengers.size - 1) {
      this.goToNextPage();
    } else {
      this.setState({
        hasSeatBeenSelected: true,
      });
    }
  };

  goToNextPage = () => {
    const { passengerIndex, seatPassengers, type } = this.props;
    if (type === 'all' && passengerIndex < seatPassengers.size - 1) {
      this.goToPassenger(passengerIndex + 1);
    } else {
      this.props.modalActionsBound.toggleModal(AIRLINE_PASSENGER_LIST, {
        slideInFromTheSide: SLIDE_DIRECTION_LEFT,
        title: 'In-flight Seat Selection',
      });
    }
  };

  render() {
    const { seatPassengers, direction, passengerIndex, type } = this.props;
    const { hasSeatBeenSelected } = this.state;

    const seatPassenger = this.getSeatPassenger();
    const selectPrevious = (type === 'all' && passengerIndex > 0) ? this.selectPrevious : undefined;

    return (
      <div className="seat-list-modal">
        <SeatListNavigationHeader
          counter={seatPassenger.get('counter')}
          paxType={seatPassenger.get('paxType')}
          label={seatPassenger.get('label')}
          direction={direction}
          selectNext={this.goToNextPage}
          selectPrevious={selectPrevious}
          showDoneButton={hasSeatBeenSelected}
        />
        <div className="seat-list-modal__seats">
          <SeatList
            direction={direction}
            seatPassengers={seatPassengers}
            currentPassengerIndex={passengerIndex}
            onSeatSelected={this.onSeatSelected}
          />
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SeatListModal);



/** WEBPACK FOOTER **
 ** ./src/components/AirlineSeatSelection/SeatListModal.jsx
 **/